// Lansering: söndag 18 oktober 2026 kl 00:00 svensk tid
export const HALLOWEEK_LAUNCH_AT = '2026-10-18T00:00:00+02:00'
export const HALLOWEEK_DATES = 'Vecka 44 · 26 okt – 1 nov'
